import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import InputMask from "react-input-mask";

const FloatingFormInput = React.forwardRef((props, ref) => {
  const {
    name,
    label,
    containerClassName,
    labelClassName,
    required,
    type,
    error,
    isLowerCase,
    ...rest
  } = props;

  const handleOnFocus = (e) => {
    e.preventDefault();
    document.getElementById(_.get(rest, "id") || name).focus();
  };

  return (
    <div className="flex flex-col w-full relative">
      <div
        className={containerClassName}
        onClick={handleOnFocus}
        role="presentation"
      >
        <InputMask
          id={_.get(props, "id") || name}
          type={type}
          autoComplete="off"
          name={name}
          maskChar={null}
          ref={ref}
          mask="99-99-9999"
          placeholder={label}
          className={`floating-input${type === "text" ? " uppercase" : ""}`}
          {...rest}
        />
        <label className={labelClassName} htmlFor={_.get(rest, "id") || name}>
          {label} {required ? <span className="text-red-500">*</span> : ""}
        </label>
      </div>
      {error && (
        <small className="flex text-xxs absolute bottom-2 items-center gap-1 right-0 px-2 bg-red-50 rounded text-red-500">
          <i className="fa fa-exclamation-circle" /> {error?.message ?? ""}
        </small>
      )}
    </div>
  );
});

FloatingFormInput.defaultProps = {
  label: "Name",
  containerClassName: "floating-form",
  labelClassName: "floating-label",
  required: false,
  type: "text",
  error: false,
  isLowerCase: false,
};

FloatingFormInput.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.bool,
  ]),
  name: PropTypes.string.isRequired,
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.instanceOf(Object),
    PropTypes.bool,
  ]),
  isLowerCase: PropTypes.bool,
};

export default React.memo(FloatingFormInput);
